import { render } from "./IdentityTable.vue?vue&type=template&id=1b492505"
import script from "./IdentityTable.vue?vue&type=script&lang=js"
export * from "./IdentityTable.vue?vue&type=script&lang=js"

import "./IdentityTable.vue?vue&type=style&index=0&id=1b492505&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__